export default function CtaBand() {
  return (
    <section className="bg-accent-600 py-14 md:py-20" aria-label="开始阅读">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="reveal flex flex-col items-center gap-6 text-center">
          <h2 className="max-w-2xl font-heading text-2xl leading-snug text-background-50 md:text-4xl">
            挑一部喜欢的漫画，从现在这一话开始
          </h2>
          <p className="max-w-2xl text-sm leading-relaxed text-background-50/90 md:text-base">
            不必先想好用哪个设备。你可以在网页上先读两话试试，也可以直接下载客户端，把书架和进度都存进账号里。两条路的数据是互通的。
          </p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href="#download"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-accent-700 transition-colors hover:bg-background-100"
            >
              <i className="ri-download-2-line text-base" aria-hidden="true" />
              下载客户端
            </a>
            <a
              href="#library"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/60 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-white/10"
            >
              <i className="ri-book-open-line text-base" aria-hidden="true" />
              浏览漫画库
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}